// UnknownBlock — fallback-блок для неочікуваних або нових типів UI-блоків.


export default function UnknownBlock({ block }) {
  return (
    <div className="block">
      <div className="blockTitle">{block.title || block.type || "Block"}</div>
      <pre className="blockJson">{JSON.stringify(block, null, 2)}</pre>
    </div>
  );
}
